<template>
  <router-view />
</template>

<script>
export default {
  name: 'sales-pages-container',
};
</script>
